import React from "react";

const TransactionCard = (props) => {
  const timeManager = (time) => {
    if (time) {
      const splittedTime = time.split("T")[0].split("-");
      const persianDate = new Date(
        splittedTime[0],
        splittedTime[1],
        splittedTime[2]
      ).toLocaleDateString("fa-Ir");
      return persianDate;
    }
  };

  return (
    <>
      {!props.data
        ? null
        : props.data.map((el) => {
            return (
              <div className="row flex-column transaction-cards bg-white p-5 mx-auto mt-3 w-100 text-right">
                <div className="d-block d-md-flex justify-content-between">
                  <div className="col-12 col-md-6 d-flex gap-8 my-4">
                    <b className="font-17 white-nowrap">زمان و تاریخ :</b>
                    <span className="font-16">{timeManager(el.createdAt)}</span>
                  </div>
                  <div
                    className="col-12 col-md-6 my-4"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {" "}
                    <b className="font-17 white-nowrap my-4">مبلغ :</b>
                    <span>
                      <span className="mx-1 font-16"> {el.amount.toLocaleString('ar-EG')} ریال</span>
                      {+el.transactionType === -1 ? (
                        <i className="fa fa-arrow-down text-danger mx-1"></i>
                      ) : (
                        <i
                          className="fa fa-arrow-up mx-1"
                          style={{ color: "green" }}
                        ></i>
                      )}
                      <span className="mx-1 font-18">
                        {+el.transactionType === -1 ? "-" : "+"}
                      </span>
                    </span>
                  </div>
                </div>
                <div
                  className="line"
                  style={{
                    width: "95%",
                    marginBlock: "1.5%",
                    borderBottom: "1px solid gray",
                  }}
                ></div>
                <div className="d-block d-md-flex justify-content-between">
                  <div className="col-12 col-md-6  d-flex gap-8 my-4">
                    <b className="font-17 white-nowrap">نوع تراکنش :</b>
                    <span className="font-16">
                      {+el.transactionType === -1
                        ? "کاهش شارژ / اعتبار"
                        : "افزایش شارژ / اعتبار"}
                    </span>
                  </div>
                  <div className="col-12 col-md-6  d-flex gap-8 my-4">
                    {" "}
                    <b className="font-17 white-nowrap">توضیح :</b>
                    <span className="font-16">{el.description}</span>
                  </div>
                </div>
              </div>
            );
          })}
    </>
  );
};

export default TransactionCard;
